/** Query-param tab keys for `/signals` (RncDashboard). */
export const SIGNALS_TAB_RNC = "rnc";
export const SIGNALS_TAB_ABM = "custom";

export function signalsDashboardPath(tab = SIGNALS_TAB_RNC) {
  return `/signals?tab=${encodeURIComponent(tab)}`;
}
